module.exports = "https://milano-network.servercdn.it/static/fonts/FuturaPT-Demi.woff2?57b3d1b6401b8c8fbebe606d2a202474";